<template>
    <div>
        <el-form  :model="formData" ref="formRef" label-width="90px" size="mini" inline>
            <el-form-item  prop="i_gsid" :label="$t('form_company')" >{{formData.vc_gsname}}</el-form-item>
            <el-form-item  prop="i_gsid" :label="$t('collectPayment_balance')" >{{formData.vc_gsname}}</el-form-item>
            <el-form-item  prop="i_gsid" :label="$t('form_currency')" >{{formData.vc_bzname}}</el-form-item>
            <el-table
                    class="mrt10"
                    ref="table"
                    size="mini"
                    :height="tableHeight"
                    border
                    :data="tableData"
                    :highlight-current-row="true"
                    style="width: 100%;margin-right: 9px;margin-left: 9px">
                <!--                <el-table-column   align="center" type="selection" width="50px"></el-table-column>-->
                <el-table-column align="center" :label="$t('collectPayment_customer_name')" prop="vc_khname"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('form_currency')"  prop="vc_bzname" width="60"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('form_exchange_rate')"  prop="f_rate" width="60"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('collectPayment_total_application_amount')" prop="f_rate" width="120"   show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('collectPayment_remaining_amount')" prop="f_rate" width="120"   show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('form_amount')" prop="f_amount" width="120"   show-overflow-tooltip>
                    <template  slot-scope="scope">
                        <el-input-number  class="changeinput" :controls="false" :precision="2" size="mini" v-model="scope.row.f_amount" ></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('form_input_person')" width="80px" prop="vc_lruname"   show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('collectPayment_registration_date')" prop="dt_applytime" width="90px"  show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('form_notes')" prop="vc_note"    show-overflow-tooltip></el-table-column>

                <!--                <el-table-column  width="50" :label="$t('form_operate')" align="center">-->
<!--                    <template slot="header" slot-scope="scope" >-->
<!--                        <el-button  icon="el-icon-plus"  @click="addRow"   size="mini"  type="text" ></el-button>-->
<!--                    </template>-->
<!--                    <template slot-scope="scope" >-->
<!--                        <div style="text-align: center !important;">-->
<!--                            <el-button  icon="el-icon-minus"  type="text" @click="deleteRow(scope.row,scope.$index)"  size="mini" class="mrl10" ></el-button>-->

<!--                        </div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column align="center" label="备注" prop="vc_note" show-overflow-tooltip></el-table-column>-->
            </el-table>

            <div class="formDiv flex jcsb">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_input_person')" >
                    <span>{{formData.vc_lruname}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="dt_createtime" :label="$t('form_entry_date')" >
                    <span>{{formData.dt_createtime}}</span>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small" >{{$t('button_save')}}</el-button>
<!--                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">{{$t('button_edit')}}</el-button>-->
            </template>

            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>

        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {

                baseerp:'',
                formData:{

                },
                tableData:[],
                tableHeight:0,

            }
        },

        watch: {
            data: {
                handler() {
                    if (this.data) {
                        this.i_id=this.data.i_id;
                        // console.log(this.i_id,'this.i_id',this.data,'this.data')
                        this.formData=JSON.parse(JSON.stringify(this.data));

                        // this.formData.dt_paytime='2025-01-02';
                            this.formData.dt_createtime=this.getDateYYYYMMddHHMMSS();
                            this.formData.vc_lruname=sessionStorage.getItem("lruname");
                            this.formData.i_lruid=sessionStorage.getItem("userid");

                        this.getPaymentApplies()

                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            // this.getKhlistWithNoRights();
            // this.getCompanyList();
            // this.getbzlist();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            saveForm(){

                this.manaulProcessHx();
                this.disabled=true;

            },
            cancel(){
                this.$emit('close')
            },
            async manaulProcessHx(){
                let param={
                    i_fkid:this.formData.i_id,
                    i_gsid:this.formData.i_gsid,
                    f_rate:this.formData.f_rate,
                    i_sqids:this.tableData,
                };
                let res=await API.manaulProcessHx(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message);
                    this.$emit('close','save');
                    this.disabled=false;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false;
                }
            },

            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`

            },
            async getPaymentApplies(){
                let param={
                    i_gsid:this.formData.i_gsid,
                    i_khid:this.formData.i_bzid,
                };
                let res=await API.getPaymentApplies(param);
                if ( res.code == 1 ){
                    this.tableData=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display:flex;
    }
    .jcsb{
        justify-content: space-between;

    }
</style>